module.exports = __webpack_public_path__ + "img/2.51b33b93.png";